import Vue from 'vue'

let VueI18n

// 尝试加载 vue-i18n
try {
  // 使用 require 替代 import，通常能更可靠地解析 CommonJS 模块
  VueI18n = require('vue-i18n')
} catch (e) {
  console.error('[PestAI] Failed to require vue-i18n:', e)
}

// 处理 ES Module 的 default 导出
if (VueI18n && VueI18n.default) {
  VueI18n = VueI18n.default
}

// 获取本地存储的语言设置
const savedLocale = localStorage.getItem('user_language') || 'zh'

// 验证是否加载到了有效的插件构造函数
const isLegacyI18n = typeof VueI18n === 'function'

if (isLegacyI18n) {
  // 安装真正的插件
  Vue.use(VueI18n)
} else {
  console.error('[PestAI] VueI18n failed to load correctly. Using fallback to prevent crash.')
  console.log('[PestAI] Debug info - VueI18n loaded as:', VueI18n)
  
  // 注册伪造插件，防止页面白屏
  Vue.use({
    install(Vue) {
      Vue.prototype.$t = (key) => {
        if (!key) return ''
        const parts = key.split('.')
        return parts[parts.length - 1]
      }
      // 创建一个非响应式的简单的 $i18n 对象
      Vue.prototype.$i18n = { locale: savedLocale }
    }
  })
}

const messages = {
  zh: {
    sidebar: {
      title: '病虫害捕手',
      analysis: '病害分析',
      newChat: '新建对话',
      logout: '退出登录',
      confirmLogout: '确定要退出登录吗？',
      language: 'English'
    },
    welcome: {
      title: 'Hi～我是病虫害捕手',
      subtitle: '病虫害捕手是基于神农大模型研发的作物病虫害识别',
      description: '病虫害捕手是基于神农大模型研发的作物病虫害识别，用户可以上传作物图片并描述问题，让AI帮您诊断作物疾病，当前支持番茄、黄瓜、辣椒等75种农作物的615种常见病虫害准确识别。',
      hintTitle: '您可以这样问...',
      hints: [
        '水稻稻飞虱的防治方法有哪些？',
        '小麦白粉病的发生条件和防治措施是什么？',
        '如何绿色防控苹果园的蚜虫？'
      ]
    },
    chat: {
      placeholder: '上传作物图片并描述问题，让AI帮您诊断作物疾病，当前支持番茄、黄瓜、辣椒等75种农作物的615种常见病虫害准确识别。',
      upload: '上传图片',
      clear: '清空对话',
      send: '发送',
      cropSelectPrompt: '请选择作物类型，如果不存在，请直接输入',
      maxImages: '最多只能上传1张图片',
      uploadTips: '请上传图片文件',
      sampleImages: {
        corn: '玉米',
        cotton: '棉花',
        pepper: '辣椒',
        peony: '牡丹',
        rice: '水稻',
        tomato: '番茄',
        wheat: '小麦'
      }
    },
    result: {
      veryHigh: '极大概率',
      high: '大概率',
      medium: '中等概率',
      low: '小概率',
      veryLow: '极小概率',
      unknownDisease: '未知病害',
      unknownCrop: '未知作物',
      healthy: '健康',
      treatment: '治疗方案建议',
      physical: '物理防治方法',
      biological: '生物防治方法',
      chemical: '化学防治方法'
    },
    login: {
      title: '病虫害捕手',
      subtitle: '基于神农大模型研发的作物病虫害识别',
      username: '用户名',
      password: '密码',
      login: '登录',
      loggingIn: '登录中...',
      inputError: '请输入账号和密码',
      loginError: '账号或密码错误，请重试',
      description: '病虫害捕手支持番茄、黄瓜、辣椒等75种农作物的615种常见病虫害准确识别'
    },
    app: {
      cottonModal: {
        title: '棉花炭疽病',
        probability: '极大概率',
        featureTitle: '特征描述',
        preventionTitle: '防治方法',
        feature: '病斑初呈圆形或近圆形，颜色为黄褐色至深褐色，边缘清晰；病斑中央凹陷，有时呈现同心轮纹状；叶片严重感病时出现穿孔现象，果实受害后出现深陷的黑色病斑；高温高湿条件下病害发展迅速，雨后传播加剧。',
        physics: '- 选择排水良好的田块，避免积水造成的高湿环境<br>- 合理密植，保证田间通风透光，降低湿度<br>- 及时清除病残体，减少病原菌越冬场所<br>- 实行轮作制度，与非茄科作物轮作2-3年<br>- 雨后及时排水，减少田间湿度',
        chemistry: '- 发病初期喷施甲基硫菌灵或多菌灵进行预防<br>- 使用咪鲜胺、苯醚甲环唑等三唑类杀菌剂治疗<br>- 严重时可用氟环唑、丙环唑等内吸性杀菌剂<br>- 每10-15天喷药一次，连续2-3次<br>- 雨前雨后及时补喷，确保药效持续',
        biology: '- 应用枯草芽孢杆菌等生物制剂进行土壤处理<br>- 喷施木霉菌制剂抑制病原菌生长繁殖<br>- 使用放线菌提取物增强植株抗病能力<br>- 施用微生物有机肥改善土壤微生态环境<br>- 叶面喷施海藻提取物等生物刺激素'
      },
      peonyModal: {
        title: '牡丹缺铁黄叶病',
        probability: '大概率',
        featureTitle: '特征描述',
        preventionTitle: '防治方法',
        feature: '叶片从叶脉间开始发黄，逐渐扩展至整个叶片，叶脉仍保持绿色，形成典型的网状花纹；严重时叶片边缘出现褐色焦枯，甚至脱落；新叶比老叶症状更明显，植株生长势减弱，开花质量下降。',
        physics: '- 彻底清除病残落叶，剪除茎基部病残枝，集中烧毁或深埋<br>- 检测土壤pH值，增施有机肥改善土壤结构，降低土壤碱性<br>- 适当密植，防止湿气滞留，雨后及时排水避免积水<br>- 设置遮荫物，避免阳光直射，减少水分蒸发和铁元素流失<br>- 合理控制土壤酸碱度，保持pH值在7.3以下',
        chemistry: '- 每平方米施用硫酸亚铁50-100克或硫磺粉30-50克调节土壤酸碱度<br>- 喷施0.1%-0.3%硫酸亚铁溶液，每隔7-10天一次，连续2-3次<br>- 使用含铁螯合物如EDTA铁等，稳定性和吸收率更高<br>- 施用过磷酸钙、磷酸二铵等生理酸性肥料降低土壤碱性<br>- 避免过量使用，防止土壤酸度过高影响牡丹生长',
        biology: '- 增施含腐殖酸的有机肥，每亩施用1000-2000公斤有机肥<br>- 施用含有益微生物的生物菌肥，如5406抗生菌菌种粉<br>- 有机肥中掺入适量硫酸亚铁，提高铁元素有效性<br>- 利用微生物与根系共生关系，促进铁元素吸收<br>- 改善土壤结构，增强土壤肥力，提高植株抗病能力'
      }
    }
  },
  en: {
    sidebar: {
      title: 'Pest Catcher',
      analysis: 'Disease Analysis',
      newChat: 'New Chat',
      logout: 'Logout',
      confirmLogout: 'Are you sure you want to log out?',
      language: '中文'
    },
    welcome: {
      title: 'Hi~ I am Pest Catcher',
      subtitle: 'Based on Shennong Large Model',
      description: 'Pest Catcher is based on the Shennong Large Model. Users can upload crop images and describe problems to let AI help diagnose crop diseases. Currently supports 75 crops including tomatoes, cucumber, peppers and 615 common pests.',
      hintTitle: 'You can ask like this...',
      hints: [
        'What are the control methods for rice planthoppers?',
        'What are the conditions and control measures for wheat powdery mildew?',
        'How to control aphids in apple orchards in a green way?'
      ]
    },
    chat: {
      placeholder: 'Upload crop images and describe the problem, let AI help diagnose crop diseases. Currently supports 75 crops and 615 common pests.',
      upload: 'Upload Image',
      clear: 'Clear Chat',
      send: 'Send',
      cropSelectPrompt: 'Please select crop type, or list if not present',
      maxImages: 'Only 1 image can be uploaded',
      uploadTips: 'Please upload an image file',
      sampleImages: {
        corn: 'Corn',
        cotton: 'Cotton',
        pepper: 'Pepper',
        peony: 'Peony',
        rice: 'Rice',
        tomato: 'Tomato',
        wheat: 'Wheat'
      }
    },
    result: {
      veryHigh: 'Very High Prob',
      high: 'High Probability',
      medium: 'Medium Probability',
      low: 'Low Probability',
      veryLow: 'Very Low Prob',
      unknownDisease: 'Unknown Disease',
      unknownCrop: 'Unknown Crop',
      healthy: 'Healthy',
      treatment: 'Treatment Suggestions',
      physical: 'Physical Control Methods',
      biological: 'Biological Control Methods',
      chemical: 'Chemical Control Methods'
    },
    login: {
      title: 'Pest Catcher',
      subtitle: 'Based on Shennong Large Model',
      username: 'Username',
      password: 'Password',
      login: 'Login',
      loggingIn: 'Logging in...',
      inputError: 'Please enter username and password',
      loginError: 'Incorrect username or password',
      description: 'Pest Catcher supports accurate identification of 615 common pests and diseases of 75 crops.'
    },
    app: {
      cottonModal: {
        title: 'Cotton Anthracnose',
        probability: 'Very High Prob',
        featureTitle: 'Feature Description',
        preventionTitle: 'Prevention Methods',
        feature: 'Lesions are initially circular or near-circular, yellow-brown to dark brown in color with clear edges; centers are sunken, sometimes showing concentric rings; severe leaf infection leads to perforation; fruit infection causes sunken black spots; disease develops rapidly under high temperature and humidity, spreading intensifies after rain.',
        physics: '- Select well-drained fields to avoid high humidity<br>- Reasonable planting density to ensure ventilation<br>- Remove crop residues<br>- Implement crop rotation<br>- Drain timely after rain',
        chemistry: '- Spray thiophanate-methyl or carbendazim for prevention<br>- Use triazole fungicides like prochloraz<br>- Use systemic fungicides for severe cases<br>- Spray every 10-15 days, 2-3 times<br>- Re-spray prompt before/after rain',
        biology: '- Apply Bacillus subtilis for soil<br>- Spray Trichoderma preparations<br>- Use actinomycete extracts<br>- Apply microbial organic fertilizer<br>- Foliar spray of biostimulants'
      },
      peonyModal: {
        title: 'Peony Iron Deficiency Chlorosis',
        probability: 'High Probability',
        featureTitle: 'Feature Description',
        preventionTitle: 'Prevention Methods',
        feature: 'Leaves begin to yellow between veins, expanding to whole leaf while veins remain green (reticulate pattern); severe cases show brown scorched edges or leaf drop; new leaves show symptoms more than old ones; plant growth weakens, flowering quality declines.',
        physics: '- Remove diseased leaves/branches and destroy at base<br>- Test soil pH, apply organic fertilizer to reduce alkalinity<br>- Proper planting density and drainage<br>- Shade from direct sunlight to reduce evaporation<br>- Keep soil pH below 7.3',
        chemistry: '- Apply ferrous sulfate (50-100g/m²) or sulfur (30-50g/m²)<br>- Spray 0.1%-0.3% ferrous sulfate solution every 7-10 days (2-3 times)<br>- Use iron chelates like EDTA iron<br>- Apply physiological acidic fertilizers<br>- Avoid excessive use to prevent high acidity',
        biology: '- Apply humic acid organic fertilizer (1000-2000kg/mu)<br>- Apply beneficial microbial fertilizers (e.g., 5406)<br>- Mix ferrous sulfate with organic fertilizer<br>- Promote microorganism-root symbiosis for iron absorption<br>- Improve soil structure and fertility'
      }
    }
  }
}

// 初始化 i18n 实例
let i18n
if (isLegacyI18n) {
  i18n = new VueI18n({
    locale: savedLocale,
    fallbackLocale: 'zh',
    messages
  })
} else {
  // 返回一个空对象给 main.js 的 new Vue({ i18n }) 使用，避免报错
  // 这种情况下，翻译功能是不可用的（只能显示 Mock 文本）
  i18n = { locale: savedLocale }
}

export default i18n
